export default __webpack_public_path__ + "static/media/icon-eye-cut.e402b65a.svg";